/**
 * 为 designer-editor 的模板导入和素材保存重建 Canvas 图片特效结果
 *
 * 该模块负责在离屏计算前初始化图片 WASM，并把 editor-next 生成的特效产物转换为可上传 URL。
 */
import { rebuildImageLayerEffect } from '@meitu/saas-editor-core/es/layers/image-layer/render/render-to-canvas';
import { base64Kit } from '@meitu/saas-editor-core/es/utils/base64-kit';
import { type ILayerProps } from '@meitu/saas-editor-core/es/version-types';
import { imageKit, setConfig, type IConfig } from '@meitu/wasm-lib';
import { PUBLIC_URL } from '@/react-process-env';

let initialized = false;

/**
 * 重建图片图层特效并返回远程可访问地址
 *
 * @param layer - 包含图片特效配置的图层
 * @returns 特效截图对应的远程地址
 */
export const renderImageEffectToUrl = async (layer: ILayerProps): Promise<string> => {
    if (!initialized && PUBLIC_URL) {
        const prefix = PUBLIC_URL.replace(/^\./, '').replace(/\/$/, '');
        setConfig({ debug: false } as IConfig, prefix);
        await imageKit.init(prefix);
    }
    initialized = true;

    const artifact = await rebuildImageLayerEffect(layer);
    return base64Kit.getRemoteUrlAsync(artifact.screenshotUrl);
};
